import React from "react";
import "./offer.css";
import type { ProductItem } from "../../types/catalog";
import { useI18n } from "../../i18n/I18n";

interface OfferProps extends ProductItem {
  offers: ProductItem[];
  setOffers: React.Dispatch<React.SetStateAction<ProductItem[]>>;
}

function Offer({id,img,title,price,offers,setOffers}: OfferProps){
  const { language, t } = useI18n();
  return <div className="offer-card"><div className="offer-card__content"><img className="offer-card__content-img" src={img} alt={title}/><p className="offer-card__content-text">{title}</p><p className="offer-card__content-price">{Number(price).toLocaleString(language === "uk" ? "uk-UA" : "en-US")} ₴</p><button className="offer-card__content-button" onClick={()=>setOffers(offers.filter(el=>el.id!==id))}>{t("remove")}</button></div></div>;
}
export default Offer;
